module.exports = __webpack_public_path__ + "static/media/km.9bb079c7.svg";